document.addEventListener("DOMContentLoaded", function () {

    // if click on "boton más - incrementar"
    $('.btn-increment').click(function (e) {
        e.preventDefault();

        var itemId = $(this).data('item-id');
        itemId = parseInt(atob(itemId), 10);
        var currentUrl = window.location.href;
        var urlParts = currentUrl.split('/');
        var baseUrl = urlParts[0] + '//' + urlParts[2];

        var subAction = "";
        var radio1 = document.getElementById("radio_entrega1");
        if(radio1.checked){
            console.log("add_shipping_cost")
            subAction = "add_shipping_cost";
        }else{
            console.log("remove_shipping_cost")
            subAction = "remove_shipping_cost";
        }

        var finalUrl = baseUrl + '/cart/' + itemId + '/update';

        $.ajax({
            url: finalUrl,
            method: 'GET',
            data: {
                action: 'increment',
                action2: subAction,
            },
            success: function (response) {
                $('#quantity-display').text(response.quantity);
                $('#quantity-input').val(response.quantity);

                if (response.quantity > 0) {
                    var total = response.price * response.quantity;
                    $('#modal-calculatedPrice').text(total.toFixed(2));

                    var total_monthly = total / response.attributes.months;
                    $('#modal-total-calculated').text(response.attributes.months + " pagos de $ " + total_monthly.toFixed(2));
                }
            },
            error: function (error) {
                console.error('Error al procesar la cantidad del producto:', error);
            }
        });
    });

    // if click on "boton menos - decrementar"
    $('.btn-decrement').click(function (e) {
        e.preventDefault();

        var itemId = $(this).data('item-id');
        itemId = parseInt(atob(itemId), 10);

        var currentUrl = window.location.href;
        var urlParts = currentUrl.split('/');
        var baseUrl = urlParts[0] + '//' + urlParts[2];

        var subAction = "";
        var radio1 = document.getElementById("radio_entrega1");
        if(radio1.checked){
            console.log("add_shipping_cost")
            subAction = "add_shipping_cost";
        }else{
            console.log("remove_shipping_cost")
            subAction = "remove_shipping_cost";
        }

        var finalUrl = baseUrl + '/cart/' + itemId + '/update';

        $.ajax({
            url: finalUrl,
            method: 'GET',
            data: {
                action: 'decrement',
                action2: subAction,
            },
            success: function (response) {
                $('#quantity-display').text(response.quantity);
                $('#quantity-input').val(response.quantity);

                if (response.quantity > 0) {
                    var total = response.price * response.quantity;
                    $('#modal-calculatedPrice').text(total.toFixed(2));

                    var total_monthly = total / response.attributes.months;
                    $('#modal-total-calculated').text(response.attributes.months + " pagos de $ " + total_monthly.toFixed(2));
                }
            },
            error: function (error) {
                console.error('Error al procesar la cantidad del producto:', error);
            }
        });
    });

    // if select "Envio a domicilio"
    $('#radio_entrega1').change(function (e) {
        e.preventDefault();

        if ($("#radio_entrega1").prop("checked")) {

            var itemId = $(this).data('item-id');
            itemId = parseInt(atob(itemId), 10);

            var currentUrl = window.location.href;
            var urlParts = currentUrl.split('/');
            var baseUrl = urlParts[0] + '//' + urlParts[2];

            var finalUrl = baseUrl + '/cart/' + itemId + '/update';

            $.ajax({
                url: finalUrl,
                method: 'GET',
                data: {
                    action: 'nothing',
                    action2: 'add_shipping_cost',
                },
                success: function (response) {
                    $('#quantity-display').text(response.quantity);
                    $('#quantity-input').val(response.quantity);

                    if (response.quantity > 0) {
                        var total = response.price * response.quantity;
                        $('#modal-calculatedPrice').text(total.toFixed(2));

                        var total_monthly = total / response.attributes.months;
                        $('#modal-total-calculated').text(response.attributes.months + " pagos de $ " + total_monthly.toFixed(2));
                    }
                },
                error: function (error) {
                    console.error('Error al procesar la cantidad del producto:', error);
                }
            });
        }
    });

    // if select "Recoger en tienda"
    $('#radio_entrega2').change(function (e) {
        e.preventDefault();

        if ($("#radio_entrega2").prop("checked")) {

            var itemId = $(this).data('item-id');
            itemId = parseInt(atob(itemId), 10);

            var currentUrl = window.location.href;
            var urlParts = currentUrl.split('/');
            var baseUrl = urlParts[0] + '//' + urlParts[2];

            var finalUrl = baseUrl + '/cart/' + itemId + '/update';

            $.ajax({
                url: finalUrl,
                method: 'GET',
                data: {
                    action: 'nothing',
                    action2: 'remove_shipping_cost',
                },
                success: function (response) {
                    $('#quantity-display').text(response.quantity);
                    $('#quantity-input').val(response.quantity);

                    if (response.quantity > 0) {
                        var total = response.price * response.quantity;
                        $('#modal-calculatedPrice').text(total.toFixed(2));

                        var total_monthly = total / response.attributes.months;
                        $('#modal-total-calculated').text(response.attributes.months + " pagos de $ " + total_monthly.toFixed(2));
                    }
                },
                error: function (error) {
                    console.error('Error al procesar la cantidad del producto:', error);
                }
            });
        }
    });

    // if select "create acount"
    $('#id_create_account').change(function (e) {
        e.preventDefault();
        if ($("#id_create_account").prop("checked")) {
            $("#id_create_account_passwords_area").show();
        }
        else {
            $("#id_create_account_passwords_area").hide();
        }
    });

});
